import React, { useState } from 'react'
import { apiDelete } from '~/util/api'
import { useQueryClient } from '@tanstack/react-query'
import { XCircleIcon } from '@heroicons/react/24/outline'
import safeParse from '~/lib/safeParse'
import Spinner from '../shared/Spinner'

const Notification = ({ notification, current_user, archived }) => {
  const { id, sender, created_at, message } = notification
  const [isArchiving, setIsArchiving] = useState(false)

  const queryClient = useQueryClient()

  const handleArchive = async () => {
    setIsArchiving(true)
    const res = await apiDelete(
      `/coach/internal_alert_recipients/${current_user.id}`,
      {
        data: {
          internal_alert_id: id,
        },
      },
    )
    if (res.status === 200) {
      queryClient.invalidateQueries({ queryKey: ['notifications'] })
    } else {
      console.error('Failed to archive notification:', res)
    }
  }

  return (
    <div className="flex min-h-48 flex-col gap-2 rounded-lg border border-solid border-silver bg-white p-4">
      {isArchiving ? (
        <div className="flex items-center justify-center">
          <Spinner show size={9} />
        </div>
      ) : (
        <>
          <div className="flex justify-between border-b border-silver-400 px-4 py-2 font-bold">
            {sender}
            {!archived && (
              <button
                onClick={handleArchive}
                title="Archive this notification"
                className="remove-alert flex items-center gap-1"
              >
                <XCircleIcon
                  className="h-5 w-5 text-[#D82727]"
                  aria-hidden="true"
                />
                <span className="sr-only">Archive this notification</span>
              </button>
            )}
          </div>

          <div className="rich-text min-h-36 p-4">{safeParse(message)}</div>

          <div className="w-full p-4 text-right text-sm">{created_at}</div>
        </>
      )}
    </div>
  )
}
export default Notification
